module.exports = __webpack_public_path__ + "img/logo-black@2x.55198081.png";